<template>
  <div class="wechatauthorize-page">
    <div class="wp-top">
      <img src="@/assets/img/icon64_appwx_logo.png" >
      <h2>微信授权</h2>
      <p>点击下方授权按钮，确认绑定微信。</p>
    </div>
    <div class="wp-bottom">
      <a class="el-button" :href="'https://www.simplybrand.com/apis/v3/task/wechat/wechatlogin?taskid=' + taskid">确认授权</a>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      taskid: window.location.href.split('=')[1]
    }
  },
}
</script>

<style>
  .wechatauthorize-page{
    max-width: 750px;
    padding: 30px;
    position: relative;
    margin: auto;
  }
  .wp-top{
    height: calc(50vh - 30px);
    text-align: center;
  }
  .wp-top p{
    font-size: 14px;
    color: #999;
  }
  .wp-top img{
    margin-top: 60px;
  }
  .wp-top h2{
    font-weight: normal;
    font-size: 24px;
    margin-top: 15px;
  }
  .wp-bottom{
    height: calc(50vh - 30px);
  }
  .wp-bottom a{
    width: 100%;
    max-width: 300px;
    margin: auto;
    display: block;
    text-decoration: none;
    background-color: #2aae67;
    color: #fff;
  }
</style>